<template>
    <div style="margin: 0 40px">
      <el-form style="margin-right: 25px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="项目名称" prop="projectname">
          <el-input v-model="addEditForm.projectname" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="所属组织" prop="orgid">
          <el-cascader v-fixZoom
            style="width: 100%"
            :options="orgOptions"
            v-model="addEditForm.orgid"
            :filterable="true"
            placeholder="请选择所属组织"
            :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
            ref="orgOptions">
          </el-cascader>
        </el-form-item>
        <el-form-item label="项目备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入项目备注"
            v-model="addEditForm.remark">
          </el-input>
        </el-form-item>
      </el-form>
<!--      <div style="text-align: center">-->
<!--        <el-button @click="closeAdd()">取 消</el-button>-->
<!--        <el-button type="primary" @click="submitAddEdit('addEditForm')">确 定</el-button>-->
<!--      </div>-->
      <div>
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeAdd()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddEdit('addEditForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 20px;"></div>
    </div>
</template>

<script>
import {addproject, updateproject} from '../../../api/project'

export default {
  name: 'addEditProject',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    projectAddEdit: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgOptions: [],
      addEditForm: {
        id: 0,
        projectname: '',
        remark: '',
        orgid: ''
      },
      addEditRules: {
        projectname: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        orgid: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      console.log(this.projectAddEdit)
      this.orgOptions = this.projectAddEdit.orgTree
      if (this.projectAddEdit.isAdd) {
        this.addEditForm.id = 0
      } else {
        this.addEditForm.id = this.projectAddEdit.row.id
        this.addEditForm.projectname = this.projectAddEdit.row.projectname
        this.addEditForm.remark = this.projectAddEdit.row.remark
        this.addEditForm.orgid = this.projectAddEdit.row.orgid
      }
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.projectAddEdit.isAdd) {
            addproject(this.addEditForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功添加项目',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateTablePro()
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '添加项目失败'
              })
            })
          } else {
            updateproject(this.addEditForm).then(res => {
              this.$notify({
                title: '成功',
                message: '成功修改项目',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateTablePro()
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '修改项目失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/addEditProject.vue